import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { map } from "rxjs";
import { HealthScreeningService } from "src/app/shared/services/legacy/health-screening.service";

export const healthCheckGuard: CanActivateFn = () => {
	const healthScreeningService = inject(HealthScreeningService);
	const router = inject(Router);

	return healthScreeningService.getHealthScreeningSurvey().pipe(
		map((survey) => {
			if (!survey || !survey.IncludesHealthCheck) {
				router.navigate(["/home"]);
				return false;
			}
			return true;
		}),
	);
};
